<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="名称">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="add()">添加考试</el-button>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" style="width: 100%" class="custom-table">
                <el-table-column min-width="180" prop="name" label="考试名称">
                </el-table-column>
                <el-table-column min-width="200" label="考试时间">
                    <template slot-scope="scope">
                        {{ scope.row.startTime }}<br />{{ scope.row.endTime }}
                    </template>
                </el-table-column>
                <el-table-column min-width="200" label="阅卷时间">
                    <template slot-scope="scope">
                        {{ scope.row.startDateMarker }}<br />{{ scope.row.endDateMarker }}
                    </template>
                </el-table-column>
                <el-table-column label="是否开启">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable" @change="modifyEnable(scope.row)"
                            inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="管理" width="200">
                    <template slot-scope="scope">
                        <div style="display: flex;flex-wrap: wrap;flex-direction: row;align-items: center;justify-content: center;">
                            <el-link type="primary" @click="addTeacher(scope.row)">老师管理
                            </el-link>
                            <br />
                            <el-link type="primary" @click="addStudent(scope.row)">考生管理
                            </el-link>
                            <br />
                            <el-link type="primary" @click="addQuestion(scope.row)">题库管理
                            </el-link>
                            <br />
                            <el-link type="primary" @click="updateExamState(scope.row)">考试状态</el-link>
                        </div>



                        <!-- <div class="">
                            <el-link type="primary" @click="addTeacher(scope.row)" :underline="false"><i
                                    class="iconfont icon-w_xuesheng- font20"></i><b>老师管理</b>
                            </el-link>
                            <br />
                            <el-link type="primary" @click="addStudent(scope.row)" :underline="false"><i
                                    class="ayj-icon-xuesheng font20"></i><b>考生管理</b>
                            </el-link>
                            <br />
                            <el-link type="primary" @click="addQuestion(scope.row)" :underline="false"><i
                                    class="iconfont icon-w_xuesheng- font20"></i><b>题库管理</b>
                            </el-link>
                            <br />
                            <el-link type="primary" @click="updateExamState(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>考试状态</b></el-link>
                        </div> -->
                    </template>
                </el-table-column>
                <el-table-column label="统计分析" width="250">
                    <template slot-scope="scope">
                        <!-- <div class="grid col-2 grid-h_start hgap-10">
                            <el-link type="primary" @click="examResult(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>成绩结果</b></el-link>
                            <el-link type="primary" @click="classAvg(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>班级平均</b></el-link>
                            <el-link type="primary" @click="examAnalyse(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>考试分析</b></el-link>
                            <el-link type="primary" @click="peopleNumberStatistics(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>参考统计</b></el-link>
                            <el-link type="primary" @click="readOverStatistics(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>批阅统计</b></el-link>
                            <el-link type="primary" @click="classReadOverSchedule(scope.row)" :underline="false"><i
                                    class="iconfont icon-kechengguanli font20"></i><b>批阅进度</b></el-link>

                        </div> -->
                        <div class="grid col-2 grid-h_start hgap-10" style="display: flex;flex-wrap: wrap;flex-direction: row;align-items: center;justify-content: center;">
                            <el-link type="primary" @click="examResult(scope.row)">成绩结果</el-link>
                            <el-link type="primary" @click="classAvg(scope.row)">班级平均</el-link>
                            <el-link type="primary" @click="examAnalyse(scope.row)">考试分析</el-link>
                            <el-link type="primary" @click="peopleNumberStatistics(scope.row)">参考统计</el-link>
                            <el-link type="primary" @click="readOverStatistics(scope.row)">批阅统计</el-link>
                            <el-link type="primary" @click="classReadOverSchedule(scope.row)">批阅进度</el-link>

                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="">
                            <el-popconfirm @onConfirm="remove(scope.row)" title="确认移除该考试吗？">
                                <el-link type="primary" :underline="false" slot="reference">
                                    <i class="iconfont icon-delete-fill font20 text_danger"></i><b>移除</b>
                                </el-link>
                            </el-popconfirm>
                            <br />
                            <el-link type="primary" @click="edit(scope.row)" :underline="false"><i
                                    class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <br />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>
        <EditDraw v-if="showEdit" @submit="loadData" @close="showEdit=false" :item="editItem"></EditDraw>

        <QuestionList v-if="question" @submit="loadData" @close="question=false" :item="editItem"></QuestionList>

    </div>
</template>

<style scoped>
    /* 针对特定表格的表头样式 */
    .custom-table /deep/.el-table__header tr th {
        background-color:#dcdcdc42;
        /* color: #ffffff; */
    }
</style>

<script>
    import EditDraw from './edit';
    import {
        mapMutations
    } from 'vuex';
    import QuestionList from './../questionBank/questionList.vue';

    export default {
        computed: {},
        components: {
            EditDraw,
            QuestionList,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    keywords: "",
                    enable: true,
                },
                showAdd: false,
                showEdit: false,
                question: false,
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }

        },
        watch: {
            "form": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            add() {
                this.editItem = {};
                this.showEdit = true;
            },
            modifyEnable(item) {
                this.$ajaxGet("/exam/toggleEnable/" + item.id + "-" + item.enable);
            },
            addStudent(item) {
                this.openTab({
                    funcKey: "school_page_exam_student_manage",
                    title: item.name + "考生管理",
                    allowDuplicate: true,
                    attr: {
                        exam: item,
                        isSelf: true
                    }
                });
            },
            addTeacher(item) {
                this.openTab({
                    funcKey: "school_page_exam_teacher_manage",
                    title: item.name + "阅卷老师管理",
                    allowDuplicate: true,
                    attr: {
                        exam: item,
                        isSelf: true
                    }
                });
            },
            addQuestion(item) {
                this.openTab({
                    funcKey: "school_menu_question",
                    title: item.name + "题库管理",
                    allowDuplicate: true,
                    attr: {
                        exam: item,
                        isSelf: true
                    }
                });

            },
            examResult(item) {
                this.openTab({
                    funcKey: "school_menu_exam_result",
                    title: item.name + "考试结果",
                    allowDuplicate: true,
                    attr: {
                        examId: item.id,
                        isSelf: true
                    }
                });
            },
            updateExamState(item) {
                this.openTab({
                    funcKey: "school_menu_exam_update_state",
                    title: item.name + "考试状态管理",
                    allowDuplicate: true,
                    attr: {
                        examId: item.id,
                        isSelf: true
                    }
                });
            },
            classAvg(item) {
                this.openTab({
                    funcKey: "school_class_avg",
                    title: item.name + "班级平均",
                    allowDuplicate: true,
                    attr: {
                        examId: item.id,
                        isSelf: true
                    }
                });
            },
            examAnalyse(item) {
                this.openTab({
                    funcKey: "school_page_exam_statistics",
                    title: item.name + "考试分析",
                    allowDuplicate: true,
                    attr: {
                        examId: item.id,
                        isSelf: true
                    }
                });
            },
            edit(item) {
                item.datesVelue = [];
                item.datesMarkerVelue = [];
                this.editItem = {
                    ...item
                };
                this.showEdit = true;
            },
            loadData() {
                this.$ajaxPost("/exam/list", {
                    form: this.form,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.showAdd = false;
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            remove(examTest) {
                this.$ajaxGet("/exam/del/" + examTest.id, data => {
                    this.loadData();
                })
            },
            peopleNumberStatistics(data) {
                this.openTab({
                    funcKey: "school_people_number_statistics",
                    title: data.name + "参考统计",
                    allowDuplicate: true,
                    attr: {
                        examId: data.id,
                        isSelf: true
                    }
                });
            },
            readOverStatistics(data) {
                this.openTab({
                    funcKey: "school_read_over_statistics",
                    title: data.name + "批阅统计",
                    allowDuplicate: true,
                    attr: {
                        examId: data.id,
                        isSelf: true
                    }
                });
            },
            classReadOverSchedule(data) {
                this.openTab({
                    funcKey: "school_class_read_over_schedule",
                    title: data.name + "班级批阅进度",
                    allowDuplicate: true,
                    attr: {
                        examId: data.id,
                        isSelf: true
                    }
                });
            },
        },

        created() {
            this.loadData();
        }

    }
</script>
